import { render, staticRenderFns } from "./action-bar.vue?vue&type=template&id=661951da&scoped=true"
import script from "./action-bar.vue?vue&type=script&lang=ts"
export * from "./action-bar.vue?vue&type=script&lang=ts"
import style0 from "./action-bar.vue?vue&type=style&index=0&id=661951da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661951da",
  null
  
)

export default component.exports